// Temporary global switch. Keep false until dashboard downloads are approved for users.
export const DOWNLOADS_ENABLED = false;
